//Javascript for the WECAN Applicant Dashboard functionality
app.ApplicantDashboard = (
    function () {
        var dashboard = {
            //Index Page
            Index: function () {
                $("#resetFiltersButton").on("click",
                    function () {
                        $("#SelectedDistrictId").val(null);
                        $("#SelectedTimespan").val(null);
                        $("#SearchText").val(null);
                        app.page.components["MyApplicationsGrid"][0].refreshGrid();
                    });

                $(document).on("component-bind-view-mode-complete-DashboardPositions component-save-complete-DashboardPositions",
                    function (e, component) {
                        //attach the edit button event listener
                        $('[data-component-role="EditButton"]', component.el).off('click').on('click', $.proxy(component.startEditMode, component));
                    });

                $(document).on("component-bind-view-mode-complete-MyApplicationsGrid",
                    function () {

                        // once grid is bound, go through rows and remove the
                        // Withdraw button if the application has not been submitted
                        var table = $(this).find("[data-component-type='MyApplicationsGrid']").find("table");
                        var trs = table.find("tr").not("thead tr");

                        trs.each(function () {
                            var canWithdraw = $(this).find("input[name='CanWithdrawString']").first().val().trim() === "True";
                            var colspan = 0;

                            var canDelete = $(this).find("input[name='CanDeleteString']").first().val().trim() === "True";

                            if (!canDelete) {
                                colspan++;
                                var columnData = $(this).find("td[data-label='DeleteLinkButton']");
                                var previousColumnData = $(columnData).prev();
                                $(previousColumnData).attr('colspan', colspan);
                                $(columnData).remove();

                            }

                            if (!canWithdraw) {
                                colspan++;
                                var columnData = $(this).find("td[data-label='WithdrawLinkButton']");
                                var previousColumnData = $(columnData).prev();
                                $(previousColumnData).attr('colspan', colspan);
                                $(columnData).remove();
                            }

                            if (!canWithdraw && !canDelete) {
                                var columnData = $(this).find("td[data-label='ApplicationLinkButton']");
                                $(columnData).attr('colspan', 2);
                            } 

                            // Check each td for the "Vacancy Closed" text
                            if ($(this).text().trim().includes("Vacancy Closed")) {
                                var html = $(this).html();
                                var updatedHtml = html.replace("Vacancy Closed", '<span style="color: darkred; font-weight: bold;">Vacancy Closed</span>');
                                $(this).html(updatedHtml);
                            }

                        });

                        $(".withdrawButton").on("click",
                            function () {
                                // have to set these in js due to limitations of the Grid
                                $(this).attr("data-toggle", "modal");
                                $(this).attr("data-target", "#confirmWithdraw");

                                var appId = $(this).parent().siblings("[data-label='ApplicationId']").first().children().first().val();
                                $("#confirmWithdrawButton").attr("data-application-id", appId);
                            }
                        );

                        $(".deleteButton").on("click",
                            function () {
                                // have to set these in js due to limitations of the Grid
                                $(this).attr("data-toggle", "modal");
                                $(this).attr("data-target", "#confirmDelete");

                                var appId = $(this).parent().siblings("[data-label='ApplicationId']").first().children().first().val();
                                $("#confirmDeleteButton").attr("data-application-id", appId);
                            }
                        );
                    });
                $("#confirmWithdrawButton").on("click",
                    function () {
                        var id = $(this).attr("data-application-id");
                        var form = $("#__AjaxAntiForgeryForm");
                        var token = $('input[name="__RequestVerificationToken"]', form).val();
                        $.ajax({
                            type: "POST",
                            data: { ApplicationId: id, __RequestVerificationToken: token },
                            url: "/Application/Withdraw",
                            success: function (data) {
                                if (data) { //close modal
                                    $("#confirmWithdraw").modal("hide");
                                    //filter grid again for new html
                                    app.page.components["MyApplicationsGrid"][0].refreshGrid();
                                    toastr.success("You have successfully withdrawn your application.");
                                } else {
                                    toastr.error(
                                        "Something went wrong, please try again. If the problem persist please contact support.");
                                }
                            },
                            error: function () {
                                toastr.error("Something went wrong.");
                            }
                        });
                    }
                );
                $("#confirmDeleteButton").on("click",
                    function () {
                        var id = $(this).attr("data-application-id");
                        var form = $("#__AjaxAntiForgeryForm");
                        var token = $('input[name="__RequestVerificationToken"]', form).val();
                        $.ajax({
                            type: "POST",
                            data: { ApplicationId: id, __RequestVerificationToken: token },
                            url: "/Application/Delete",
                            success: function (data) {
                                if (data) { //close modal
                                    $("#confirmDelete").modal("hide");
                                    //filter grid again for new html
                                    app.page.components["MyApplicationsGrid"][0].refreshGrid();
                                    toastr.success("You have successfully deleted your application.");
                                } else {
                                    toastr.error(
                                        "Something went wrong, please try again. If the problem persist please contact support.");
                                }
                            },
                            error: function () {
                                toastr.error("Something went wrong.");
                            }
                        });
                    }
                );
            }
        };
        return dashboard;
    }()
);